import { render } from "./PaginationApp.vue?vue&type=template&id=37180b9e"
import script from "./PaginationApp.vue?vue&type=script&lang=js"
export * from "./PaginationApp.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__